import React from 'react';
import { motion } from 'framer-motion';
import { TrendBadge } from './shared/TrendBadge';
import { formatCurrencyCompact } from '../utils/formatters';

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.05, delayChildren: 0.2 } },
};
const item = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: [0.16, 1, 0.3, 1] } },
};

export function HeroMetrics({ comparisonAggregates, trendPercentages, googleAdsSummary, metaAdsSummary, criteoAdsSummary }) {
  const cur = comparisonAggregates?.cur || {};
  const totalRevenue = cur.totalRevenue || 0;
  const totalSpend = (googleAdsSummary?.totalCost || 0) + (metaAdsSummary?.totalSpend || 0) + (criteoAdsSummary?.totalCost || 0);
  const blendedRoas = totalSpend > 0 ? totalRevenue / totalSpend : 0;
  const curCR = comparisonAggregates?.curCR || 0;
  const eventCount = cur.eventCount || 0;
  const aov = eventCount > 0 ? totalRevenue / eventCount : 0;

  const spendTrend = null;

  const metrics = [
    { label: 'Revenue', value: formatCurrencyCompact(totalRevenue), trend: trendPercentages?.totalRevenue },
    { label: 'Blended ROAS', value: `${blendedRoas.toFixed(2)}x`, trend: null },
    { label: 'Total Spend', value: formatCurrencyCompact(totalSpend), trend: spendTrend },
    { label: 'Conv. Rate', value: `${curCR.toFixed(2)}%`, trend: trendPercentages?.conversionRate },
    { label: 'AOV', value: formatCurrencyCompact(aov), trend: null },
  ];

  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate="show"
      className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6"
    >
      {metrics.map((m) => (
        <motion.div key={m.label} variants={item} className="glass-card rounded-2xl p-5 hover-lift">
          <div className="gradient-accent-line w-12 mb-3" />
          <p className="text-xs uppercase tracking-wider text-gray-500 mb-1">{m.label}</p>
          <p className="text-3xl font-bold text-gray-900 mb-1">{m.value}</p>
          {m.trend != null && <TrendBadge value={m.trend} />}
        </motion.div>
      ))}
    </motion.div>
  );
}
